import { useQuery } from "@tanstack/react-query";
import { getVideoBenchmark, GetVideoBenchmarkReq } from "./api";
import { Benchmark } from "./types/benchmark.type";

/**
 * useGetVideoBenchmark Query
 *
 * This query is used to get the benchmark applied to a video study, for comparison against
 * each video asset's own Attention score. Mocked until the api-studio benchmark endpoint is ready.
 *
 * Query Key: [projectId, studyId, "video-benchmark"]
 */
export const useGetVideoBenchmark = ({ projectId, studyId }: GetVideoBenchmarkReq, options?: { enabled?: boolean }) => {
  return useQuery<Benchmark>({
    queryKey: [projectId, studyId, "video-benchmark"],
    throwOnError: true,
    queryFn: () => getVideoBenchmark({ projectId, studyId }),
    ...options,
  });
};
